export default __webpack_public_path__ + "static/media/baby-40.ab11020f.svg";